//
// navbar-dropdown.js
// Theme module
//

(function (waTheme) {

    var Dropdown = (function () {

        Dropdown = function (options) {
            var that = this;

            // DOM
            that.drops = document.querySelectorAll('.navbar-nav .dropdown, .navbar-nav .dropend, .navbar-nav .dropstart, .dropdown-hover');

            // VARS
            that.showEvents = ['mouseenter', 'focusin'];
            that.hideEvents = ['mouseleave', 'click', 'focusout'];
            that.transitionDuration = 300;
            that.transitionDelay = 50;
            that.desktopSize = 992;
            that.showClass = 'show';
            that.showingClass = 'showing';
            that.timeout = null;
            that.timeoutDelay = 200;

            // DYNAMIC VARS

            // INIT
            that.initClass();
        };

        Dropdown.prototype.initClass = function () {
            var that = this;

            that.drops.forEach(function (dropdown) {
                const menu = dropdown.querySelector('.dropdown-menu');

                // Show drop
                that.showEvents.forEach(function (event) {
                    dropdown.addEventListener(event, function () {
                        if (that.timeout != null) { clearTimeout(that.timeout); }
                        that.timeout = setTimeout(function () {
                            that.showDrop(menu);
                        }, that.timeoutDelay);
                        // that.showDrop(menu);
                    });
                });

                // Hide drop
                that.hideEvents.forEach(function (event) {
                    dropdown.addEventListener(event, function (e) {
                        if (that.timeout != null) {
                            clearTimeout(that.timeout);
                            that.timeout = null;
                            that.hideDrop(e, menu);
                        }
                        // that.hideDrop(e, menu);
                    });
                });
            });
        }

        Dropdown.prototype.showDrop = function (menu) {
            var that = this;

            if (window.innerWidth < that.desktopSize) {
                return;
            }

            menu.classList.add(that.showingClass);

            setTimeout(function () {
                menu.classList.remove(that.showingClass);
                menu.classList.add(that.showClass);
            }, that.transitionDelay);
        }

        Dropdown.prototype.hideDrop = function (e, menu) {
            var that = this;

            setTimeout(function () {
                if (window.innerWidth < that.desktopSize) {
                    return;
                }

                if (!menu.classList.contains(that.showClass)) {
                    return;
                }

                if (e.type === 'click' && (e.target.closest('.dropdown-menu form') || e.target.closest('.dropdown-menu.dropdown-menu-outside'))) {
                    return;
                }

                menu.classList.add(that.showingClass);
                menu.classList.remove(that.showClass);

                setTimeout(function () {
                    menu.classList.remove(that.showingClass);
                }, that.transitionDuration);
            }, that.transitionDelay + 1);
        }

        return Dropdown;

    })();

    waTheme.init.site.Dropdown = Dropdown;

    new window.waTheme.init.site.Dropdown();

})(window.waTheme);